import { createReducer, on } from '@ngrx/store';
import {
  closeBasketAndParts,
  hoverParts,
  isDataLoading,
  isDataLoadingCompleted,
  loadPage,
  nextPage,
  openBasket,
  prevPage,
  resetConfig,
  sidebarToggle,
  svgScaleDown,
  svgScaleReset,
  svgScaleUp,
  updateCurrentPageNumber,
  updateEndPageNumber,
  updateIsBasketVisible,
  updateIsPartsVisible,
  updatePage,
  updateStartPageNumber,
  updateUID
} from '../actions/config.actions';

export interface CONFIG {
  startPageNumber: number;
  currentPageNumber: number;
  endPageNumber: number;
  sidebarIsOpen: boolean;
  scale: number;
  dataLoading: LoadingData;
  isPartsVisible: boolean;
  isBasketVisible: boolean;
  uid: string;
  currentHoveredNumber: string;
  currentLoadedPage: string;
}

export const config: CONFIG = {
  startPageNumber: 0,
  currentPageNumber: 0,
  endPageNumber: 0,
  sidebarIsOpen: true,
  scale: 100,
  dataLoading: {
    totalFiles: 0,
    currentFiles: -1,
    success: false,
    progress: false
  },
  isPartsVisible: false,
  isBasketVisible: false,
  uid: '',
  currentHoveredNumber: '',
  currentLoadedPage: ''
};

export interface LoadingData {
  totalFiles?: number;
  currentFiles?: number;
  success: boolean;
  progress: boolean;
}

export const configReducer = createReducer(
  config,
  on(isDataLoading, (state) => {
    return {
      ...state,
      dataLoading: { ...state.dataLoading, progress: true }
    };
  }),
  on(isDataLoadingCompleted, (state) => {
    return {
      ...state,
      dataLoading: { ...state.dataLoading, progress: false, success: true }
    };
  }),
  on(sidebarToggle, (state, { value }) => {
    return {
      ...state,
      sidebarIsOpen: value === undefined ? !state.sidebarIsOpen : value
    };
  }),
  on(svgScaleUp, (state) => {
    const scale = state.scale + 10;
    return {
      ...state,
      scale: scale <= 200 ? scale : 200
    };
  }),
  on(svgScaleDown, (state) => {
    const scale = state.scale - 10;
    return {
      ...state,
      scale: scale > 100 ? scale : 100
    };
  }),
  on(svgScaleReset, (state) => {
    return {
      ...state,
      scale: 100
    };
  }),
  on(updateCurrentPageNumber, (state, { currentPageNumber }) => {
    if (typeof currentPageNumber !== 'number' || (currentPageNumber > state.endPageNumber && state.endPageNumber > 0)) {
      return { ...state };
    }
    return {
      ...state,
      currentPageNumber
    };
  }),
  on(updateStartPageNumber, (state, { startPageNumber }) => {
    return {
      ...state,
      startPageNumber
    };
  }),
  on(updateEndPageNumber, (state, { endPageNumber }) => {
    return {
      ...state,
      endPageNumber
    };
  }),
  on(prevPage, (state) => {
    return {
      ...state,
      currentPageNumber: state.currentPageNumber - 1
    };
  }),
  on(nextPage, (state) => {
    return {
      ...state,
      currentPageNumber: state.currentPageNumber + 1
    };
  }),
  on(updatePage, (state, { pageNumber }) => {
    // console.log('pageNumber', pageNumber);
    return {
      ...state,
      currentPageNumber: pageNumber
    };
  }),
  on(updateUID, (state, { uid }) => {
    return {
      ...state,
      uid
    };
  }),
  on(updateIsPartsVisible, (state, { value }) => {
    return {
      ...state,
      isBasketVisible: false,
      isPartsVisible: value === undefined ? !state.isPartsVisible : value
    };
  }),
  on(updateIsBasketVisible, (state, { value }) => {
    return {
      ...state,
      isPartsVisible: false,
      isBasketVisible: value === undefined ? !state.isBasketVisible : value
    };
  }),
  on(openBasket, (state) => {
    return {
      ...state,
      isPartsVisible: false,
      isBasketVisible: true
    };
  }),
  on(closeBasketAndParts, (state) => {
    return {
      ...state,
      isPartsVisible: false,
      isBasketVisible: false
    };
  }),
  on(hoverParts, (state, { currentHoveredNumber }) => {
    return {
      ...state,
      currentHoveredNumber
    };
  }),
  on(loadPage, (state, { currentLoadedPage }) => {
    return {
      ...state,
      currentLoadedPage
    };
  }),
  on(resetConfig, (state) => config)
);
